import { CertificationType } from 'src/common/enums/certification';
import SAL1Image from 'src/images/svgs/certifications/certificate-banner-placeholder.svg';
import pt1Image from 'src/images/svgs/certifications/pt1_top_banner.svg';

import type { CertificationAppBannerContent } from './certification-app-banner.types';

export const certificationAppBannerContent: Record<
  CertificationType,
  Omit<CertificationAppBannerContent, 'onClick'>
> = {
  [CertificationType.SAL1]: {
    title: 'The',
    highlightedTitle: 'defensive certification',
    subtitle: 'that gets you hired',
    description:
      'Stand out with Security Analyst Level 1 (SAL1). An entry-level, hands-on security analyst certification built by industry experts. Prove your skills, showcase real-world experience, and launch your cyber security career.',
    image: SAL1Image,
    buttonText: 'Learn more',
    learnMorePath: '/certification/security-analyst-level-1',
    segmentEventName: 'sal1-ad-click',
    segmentEventCategory: 'certification-banner-ad',
    segmentEventAction: 'learn-more',
  },
  [CertificationType.PT1]: {
    title: 'The new',
    highlightedTitle: 'Jr Penetration Tester',
    subtitle: 'certification that gets you hired',
    description:
      'Become job-ready with a practical offensive certification designed by industry-experts, and offensive security professionals.',
    image: pt1Image,
    buttonText: 'Learn more',
    learnMorePath: '/certification/junior-penetration-tester',
    segmentEventName: 'pt1-ad-click',
    segmentEventCategory: 'certification-banner-ad',
    segmentEventAction: 'learn-more',
  },
};
